// extracted by mini-css-extract-plugin
export default {"templateWrapper":"TemplatesView_templateWrapper__5jwkz","pre":"TemplatesView_pre__tvRBT","errorAlert":"TemplatesView_errorAlert__hmwCB"};